import React, { FC } from 'react';

import ReadingsPage from "@/components/readings/ReadingsPage";
import { Medium } from "@/constants/mediums";

const GasReadingsPage: FC = () => {
  return <ReadingsPage medium={Medium.gas} />;
};

export default GasReadingsPage;
